module.exports = __webpack_public_path__ + "img/kristoffer.0a7aa645.png";